import { StatusBadge } from "@/components/ui/status-badge";
import type { SupportTicketStatus } from "@/lib/api/support";
import { TICKET_STATUS_LABELS } from "@/lib/api/support";

type Variant = "success" | "warning" | "info" | "danger" | "neutral" | "purple";

const STATUS_VARIANT: Record<SupportTicketStatus, Variant> = {
  OPEN: "info",
  PENDING_STAFF: "warning",
  PENDING_PATRON: "purple",
  RESOLVED: "success",
  CLOSED: "neutral",
};

interface TicketStatusBadgeProps {
  status: SupportTicketStatus;
  /** Flip PENDING_STAFF/PATRON labels from the patron's perspective. */
  patronView?: boolean;
}

export function TicketStatusBadge({ status, patronView = false }: TicketStatusBadgeProps) {
  const label = patronView
    ? status === "PENDING_STAFF"
      ? "Waiting on library"
      : status === "PENDING_PATRON"
        ? "Waiting on you"
        : TICKET_STATUS_LABELS[status]
    : status === "PENDING_STAFF"
      ? "Awaiting reply"
      : status === "PENDING_PATRON"
        ? "Patron notified"
        : TICKET_STATUS_LABELS[status];

  return <StatusBadge variant={STATUS_VARIANT[status]}>{label}</StatusBadge>;
}
